export function stockTabsAnchors() {
  const navBtns = document.querySelectorAll('.stock__tabs-nav-btn');

  navBtns.forEach(item => {
    item.addEventListener('click', () => {
      const targetSection = document.getElementById('stock-tabs-content');

      if (targetSection) {
        targetSection.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
          inline: 'nearest'
        });
      }
    });
  });
}
